<div class="container text-center" id="content">
  <div class="error-emoji">(*_*)</div>
  <p>{{ message() }}</p>
</div>
